import { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext();

function getInitialLang() {
  try {
    const url = new URL(window.location.href);
    const urlLang = url.searchParams.get("lang");
    if (urlLang) return urlLang;
  } catch (e) {
    // ignore
  }
  const saved = localStorage.getItem("lang");
  return saved || "fi";
}

export function LangProvider({ children }) {
  const [langState, setLangState] = useState(getInitialLang);

  useEffect(() => {
    // ensure URL reflects current lang on initial load
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get("lang") !== langState) {
        url.searchParams.set("lang", langState);
        window.history.replaceState({}, "", url.toString());
      }
    } catch (e) {}
  }, [langState]); // update URL when language state changes

  function setLang(newLang) {
    setLangState(newLang);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("lang", newLang);
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
    try {
      localStorage.setItem("lang", newLang);
    } catch (e) {}
  }

  return (
    <LangContext.Provider value={{ lang: langState, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
